export const SDK_MODAL = 'SDKModal';
export const USER_LEGAL_INFO_MODAL = 'UserLegalInfoModal';
export const TOS_MODAL = 'TosModal';
